// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/transport/templates/transport.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_attrs0 = {
        "class": "transport"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("7e9543"),
    marko_node0 = marko_createElement("div", {
        "class": "item"
      }, "1", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "new"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-file-alt"
          }, null, null, 0),
    marko_node1 = marko_createElement("div", {
        "class": "item"
      }, "4", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "save"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-save"
          }, null, null, 0),
    marko_node2 = marko_createElement("div", {
        "class": "item"
      }, "7", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "load"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-file-upload"
          }, null, null, 0),
    marko_node3 = marko_createElement("div", {
        "class": "item"
      }, "10", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "play"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-play"
          }, null, null, 0),
    marko_node4 = marko_createElement("div", {
        "class": "item"
      }, "13", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "play-pattern"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-play-circle"
          }, null, null, 0),
    marko_node5 = marko_createElement("div", {
        "class": "item"
      }, "16", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "pause"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-pause"
          }, null, null, 0),
    marko_node6 = marko_createElement("div", {
        "class": "item"
      }, "19", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "stop"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-stop"
          }, null, null, 0),
    marko_node7 = marko_createElement("div", {
        "class": "item"
      }, "22", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "record"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-circle"
          }, null, null, 0),
    marko_node8 = marko_createElement("div", {
        "class": "item"
      }, "25", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "reset"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-step-backward"
          }, null, null, 0),
    marko_node9 = marko_createElement("div", {
        "class": "item"
      }, "28", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "export"
        }, null, null, 1)
        .e("i", {
            "class": "fa fa-file-export"
          }, null, null, 0),
    marko_attrs1 = {
        "class": "item"
      },
    marko_attrs2 = {
        "class": "item"
      },
    marko_attrs3 = {
        "class": "item"
      },
    marko_node10 = marko_createElement("div", {
        "class": "item"
      }, "43", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "control"
        }, null, null, 3)
        .e("div", {
            "class": "volume-icon fa fa-volume-down"
          }, null, null, 0)
        .e("div", {
            "class": "slider",
            id: "master-volume"
          }, null, null, 0)
        .e("div", {
            "class": "volume-icon fa fa-volume-up"
          }, null, null, 0),
    marko_attrs4 = {
        "class": "item"
      },
    marko_node11 = marko_createElement("div", {
        "class": "spacer"
      }, "51", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node12 = marko_createElement("div", {
        id: "fps",
        "class": "fps"
      }, "52", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("60.0"),
    marko_attrs5 = {
        "class": "control range"
      },
    marko_node13 = marko_createElement("label", {
        "for": "octave"
      }, "33", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Octave"),
    marko_attrs6 = {
        "class": "control range"
      },
    marko_node14 = marko_createElement("label", {
        "for": "speed"
      }, "37", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Speed"),
    marko_attrs7 = {
        "class": "control range"
      },
    marko_node15 = marko_createElement("label", {
        "for": "bpm"
      }, "41", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("BPM"),
    marko_attrs8 = {
        "class": "control"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.e("div", marko_attrs0, "0", component, 17)
    .n(marko_node0, component)
    .n(marko_node1, component)
    .n(marko_node2, component)
    .n(marko_node3, component)
    .n(marko_node4, component)
    .n(marko_node5, component)
    .n(marko_node6, component)
    .n(marko_node7, component)
    .n(marko_node8, component)
    .n(marko_node9, component)
    .e("div", marko_attrs1, "31", component, 1)
      .e("div", marko_attrs5, "32", component, 2)
        .n(marko_node13, component)
        .e("input", {
            id: "octave",
            "class": "range-input",
            value: "" + data.transport.octave,
            type: "text"
          }, "34", component, 0)
    .e("div", marko_attrs2, "35", component, 1)
      .e("div", marko_attrs6, "36", component, 2)
        .n(marko_node14, component)
        .e("input", {
            id: "speed",
            "class": "range-input",
            value: "" + data.transport.speed,
            type: "text"
          }, "38", component, 0)
    .e("div", marko_attrs3, "39", component, 1)
      .e("div", marko_attrs7, "40", component, 2)
        .n(marko_node15, component)
        .e("input", {
            id: "bpm",
            "class": "range-input",
            value: "" + data.transport.bpm,
            type: "text"
          }, "42", component, 0)
    .n(marko_node10, component)
    .e("div", marko_attrs4, "48", component, 1)
      .e("div", marko_attrs8, "49", component, 1)
        .e("input", {
            id: "songname",
            value: "" + data.songname
          }, "50", component, 0)
    .n(marko_node11, component)
    .n(marko_node12, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
